import {Component, ElementRef, ViewChild} from '@angular/core';
import { NgIf } from '@angular/common';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ned-popin',
    templateUrl: './popin-two-choices-shared.component.html',
    styleUrls: ['./popin-two-choices-shared.component.scss'],
    standalone: true,
    imports: [
        TranslateModule,
        SvgIconComponent,
        NgIf,
    ],
})
export class PopinTwoChoicesSharedComponent {

    @ViewChild('dialog') dialog!: ElementRef<HTMLDialogElement>;

    titrePopIn: string | undefined;
    messagePopIn: string | undefined;
    libelleAccepter: string | undefined;
    libelleRefuser: string | undefined;

    private opener: HTMLElement | null = null;
    private _resolver!: (value: boolean) => void;

    result: Promise<boolean> = new Promise(resolve => this._resolver = resolve);

    open() {
        this.opener = document.activeElement as HTMLElement;

        const dlg = this.dialog.nativeElement;
        dlg.showModal();

        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
    }

    close(value: boolean) {
        const dlg = this.dialog.nativeElement;
        dlg.close();

        this.opener?.focus();
        this._resolver(value);

        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
    }

}
